import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';

const routes: Routes = [
  
  { path: 'loginPage', component: LoginComponent},
  { path: 'homePage', component: HomeComponent},
  { path: 'adminHomePage', component: AdminHomeComponent},
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { useHash: true }) ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
